module.exports = __webpack_public_path__ + "img/go.24556bf1.png";